import React from 'react';
interface LogoProps {
  className?: string;
  variant?: 'default' | 'inverted';
}
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/s2DeiT2KqM4KaHzYS1VWhz/98c86b73-103f-404f-accb-d2317841f543.png';
// The source logo image has significant whitespace padding around it.
// We render it as a background-image and zoom in (backgroundSize: auto 400%)
// so the visible logo content fills the container — letting us keep a large
// visible logo while the bounding box stays compact for layout.
export function Logo({
  className = '',
  variant = 'default'
}: LogoProps) {
  const wrapperBg = variant === 'inverted' ? 'bg-white rounded-md' : '';
  return <div className={`${wrapperBg} ${className}`} style={{
    backgroundImage: `url(${LOGO_URL})`,
    backgroundSize: 'auto 240%',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
  }} aria-label="BetterCode AI" role="img" data-id="element-183" />;
}